(function () {
  var FIRST_REWARD_CENTS = 10000;
  var SECOND_REWARD_CENTS = 30000;
  var FIRST_REWARD_NAME = "Hanging Wig Storage Bag";
  var SECOND_REWARD_NAME = "Random Theme Ita Bag Decor Kit";
  var FIRST_REWARD_URL = "https://koollia.com/products/hanging-wig-storage-bag-set-dustproof-moisture-resistant-space-saving-with-hook-included-wig-stylist-tools";
  var SECOND_REWARD_URL = "https://koollia.com/products/small-anime-pin-display-shoulder-bag-randomly-multi-theme-ita-bag-decor-kit";
  var FIRST_REWARD_IMAGE = "";
  var SECOND_REWARD_IMAGE = "";

  function hasReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function canAnimate() {
    return !hasReducedMotion() && (window.gsap || (window.Element && Element.prototype.animate));
  }

  function getTargets(targets) {
    if (!targets) return [];
    if (targets instanceof Element) return [targets];
    return Array.prototype.slice.call(targets);
  }

  function easeToCss(ease) {
    if (!ease) return "ease-out";
    if (ease.indexOf("power2") === 0) return "cubic-bezier(0.22, 1, 0.36, 1)";
    if (ease.indexOf("power3") === 0) return "cubic-bezier(0.16, 1, 0.3, 1)";
    return "ease-out";
  }

  function frameFromVars(vars) {
    var frame = {};
    var transforms = [];

    if (typeof vars.y !== "undefined") transforms.push("translateY(" + vars.y + "px)");
    if (typeof vars.scale !== "undefined") transforms.push("scale(" + vars.scale + ")");
    if (transforms.length) frame.transform = transforms.join(" ");
    if (typeof vars.autoAlpha !== "undefined") frame.opacity = vars.autoAlpha;
    if (typeof vars.opacity !== "undefined") frame.opacity = vars.opacity;
    if (typeof vars.width !== "undefined") frame.width = vars.width;

    return frame;
  }

  function animateTo(targets, vars) {
    if (!canAnimate()) return;
    if (window.gsap) {
      window.gsap.to(targets, vars);
      return;
    }

    getTargets(targets).forEach(function (target) {
      var toFrame = frameFromVars(vars);
      target.animate([toFrame], {
        duration: Math.round((vars.duration || 0.4) * 1000),
        easing: easeToCss(vars.ease),
        fill: "forwards"
      });
    });
  }

  function animateFromTo(targets, fromVars, toVars) {
    if (!canAnimate()) return;
    if (window.gsap) {
      window.gsap.fromTo(targets, fromVars, toVars);
      return;
    }

    var nodes = getTargets(targets);
    var eachDelay = toVars.stagger ? Math.round(toVars.stagger * 1000) : 0;
    nodes.forEach(function (target, index) {
      var animation = target.animate([frameFromVars(fromVars), frameFromVars(toVars)], {
        duration: Math.round((toVars.duration || 0.5) * 1000),
        delay: eachDelay * index,
        easing: easeToCss(toVars.ease),
        fill: "both"
      });

      animation.addEventListener("finish", function () {
        target.style.opacity = "";
        target.style.transform = "";
        target.style.visibility = "";
      });
    });
  }

  function formatMoney(cents) {
    return "$" + (Math.max(0, cents) / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function giftStatusMarkup(total) {
    var giftName = FIRST_REWARD_NAME;
    var giftUrl = FIRST_REWARD_URL;
    var giftImage = FIRST_REWARD_IMAGE;
    var tag = "$100 gift";
    var note = formatMoney(FIRST_REWARD_CENTS - total) + " away";

    if (total >= SECOND_REWARD_CENTS) {
      giftName = SECOND_REWARD_NAME;
      giftUrl = SECOND_REWARD_URL;
      giftImage = SECOND_REWARD_IMAGE;
      tag = "$300 unlocked";
      note = "Add it in cart before checkout";
    } else if (total >= FIRST_REWARD_CENTS) {
      tag = "$100 unlocked";
      note = "Add it in cart before checkout";
    }

    var mediaHtml = giftImage
      ? '<img src="' + giftImage + '" alt="' + escapeHtml(giftName) + '" width="240" height="240" loading="lazy">'
      : '<span class="kll-june-cart-rail__gift-fallback">' + escapeHtml(giftName.charAt(0)) + '</span>';

    return '<a class="kll-june-cart-rail__gift" href="' + giftUrl + '">' +
      '<span class="kll-june-cart-rail__gift-media">' + mediaHtml + '</span>' +
      '<span class="kll-june-cart-rail__gift-copy"><span>' + tag + '</span><strong>' + escapeHtml(giftName) + '</strong><em>' + escapeHtml(note) + '</em></span>' +
    '</a>';
  }

  function updateRewardCart(page, state) {
    var totalNode = page.querySelector("[data-kll-cart-total]");
    var statusNode = page.querySelector("[data-kll-cart-status]");
    var progressNode = page.querySelector("[data-kll-cart-progress]");
    var progressTrack = page.querySelector(".kll-june-cart-rail__track");
    var itemsNode = page.querySelector("[data-kll-cart-items]");
    var total = state.baseCents + state.items.reduce(function (sum, item) {
      return sum + item.priceCents;
    }, 0);
    var progress = Math.min(100, Math.round((total / SECOND_REWARD_CENTS) * 100));

    if (totalNode) totalNode.textContent = formatMoney(total);
    if (progressNode) {
      if (canAnimate()) {
        animateTo(progressNode, {
          width: progress + "%",
          duration: 0.45,
          ease: "power2.out",
          overwrite: "auto"
        });
      } else {
        progressNode.style.width = progress + "%";
      }
    }
    if (progressTrack) progressTrack.setAttribute("aria-valuenow", String(Math.round(total / 100)));

    if (statusNode) {
      if (total < FIRST_REWARD_CENTS) {
        statusNode.textContent = formatMoney(FIRST_REWARD_CENTS - total) + " to unlock " + FIRST_REWARD_NAME + ".";
      } else if (total < SECOND_REWARD_CENTS) {
        statusNode.textContent = FIRST_REWARD_NAME + " unlocked \u2014 " + formatMoney(SECOND_REWARD_CENTS - total) + " to the next gift.";
      } else {
        statusNode.textContent = "All gifts unlocked \u2014 add yours in cart before checkout.";
      }
    }

    if (!itemsNode) return;
    itemsNode.innerHTML = giftStatusMarkup(total);
  }

  function addVariantToShopifyCart(variantId) {
    if (!variantId || !window.fetch) {
      return Promise.resolve();
    }

    return window.fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart add failed");
      return response.json();
    });
  }

  function setupRewardBarBehavior(page) {
    var shop = page.querySelector(".kll-june-shop");
    var shopMain = page.querySelector(".kll-june-shop__main");
    var rail = page.querySelector("[data-kll-cart-rail]");
    if (!shop || !rail) return;
    var wasFollowing = false;
    var lastScrollY = window.pageYOffset || document.documentElement.scrollTop;

    // Simplified header detection — same approach as the June page (which works)
    function getVisibleHeaderOffset() {
      var header = document.querySelector("sticky-header, .shopify-section-header, .header-wrapper, header");
      if (!header) return 12;
      var rect = header.getBoundingClientRect();
      // Lenient check: header is visible near top (allows for headers mid-animation)
      var isVisibleAtTop = rect.bottom > 0 && rect.top < 20;
      if (!isVisibleAtTop) return 12;
      return Math.round(rect.bottom + 8);
    }

    function updateCompactState() {
      var rect = shop.getBoundingClientRect();
      var mainRect = shopMain ? shopMain.getBoundingClientRect() : rect;
      var topOffset = getVisibleHeaderOffset();
      var currentScrollY = window.pageYOffset || document.documentElement.scrollTop;
      var scrollingUp = currentScrollY < lastScrollY;
      lastScrollY = currentScrollY;

      var isMobile = window.matchMedia("(max-width: 749px)").matches;
      // Standard condition: product grid near header AND shop not yet scrolled past
      var standardFollow = mainRect.top <= topOffset + 24 && rect.bottom > topOffset + 160;

      var shouldFollow;
      if (isMobile && wasFollowing && scrollingUp) {
        // Mobile scrolling up: keep bar fixed under nav as long as shop is still in view
        // (prevents bar from disappearing when nav slides back in from top)
        shouldFollow = rect.bottom > topOffset + 80;
      } else {
        shouldFollow = standardFollow;
      }

      page.style.setProperty("--kll-reward-top", topOffset + "px");
      page.classList.toggle("is-reward-fixed", shouldFollow);
      page.classList.toggle("is-reward-compact", shouldFollow);

      if (canAnimate() && shouldFollow && !wasFollowing) {
        animateFromTo(rail, {
          y: -10,
          autoAlpha: 0.96
        }, {
          y: 0,
          autoAlpha: 1,
          duration: 0.22,
          ease: "power2.out",
          overwrite: "auto",
          clearProps: "transform,opacity,visibility"
        });
      }

      wasFollowing = shouldFollow;

      if (!shouldFollow) {
        rail.classList.remove("is-expanded");
      }
    }

    rail.addEventListener("click", function (event) {
      if (!page.classList.contains("is-reward-compact")) return;
      if (event.target.closest("[data-kll-cart-add]")) return;
      rail.classList.toggle("is-expanded");

      if (canAnimate() && rail.classList.contains("is-expanded")) {
        animateFromTo(rail, {
          y: -4
        }, {
          y: 0,
          duration: 0.18,
          ease: "power2.out",
          overwrite: "auto",
          clearProps: "transform"
        });
      }
    });

    document.addEventListener("click", function (event) {
      if (!rail.classList.contains("is-expanded")) return;
      if (rail.contains(event.target)) return;
      rail.classList.remove("is-expanded");
    });

    window.addEventListener("scroll", updateCompactState, { passive: true });
    window.addEventListener("resize", updateCompactState);
    updateCompactState();
  }

  function revealGroup(nodes, options) {
    if (!canAnimate() || !nodes.length) return;

    animateFromTo(nodes, {
      y: options && options.y ? options.y : 18,
      autoAlpha: 0
    }, {
      y: 0,
      autoAlpha: 1,
      duration: options && options.duration ? options.duration : 0.62,
      ease: "power2.out",
      stagger: options && options.stagger ? options.stagger : 0.08,
      overwrite: "auto",
      clearProps: "transform,opacity,visibility"
    });
  }

  function setupEntranceAnimations(page) {
    if (!canAnimate()) return;

    var hero = page.querySelector(".kll-june-hero");
    if (hero) {
      var heroIntro = hero.querySelectorAll(".kll-june-hero__pill-wrapper, h1, .kll-june-hero__desc");
      var heroActions = hero.querySelectorAll(".kll-june-hero__actions > *");

      if (window.gsap) {
        var heroTimeline = window.gsap.timeline({
          defaults: {
            duration: 0.72,
            ease: "power2.out"
          }
        });

        heroTimeline.from(heroIntro, {
          y: 16,
          autoAlpha: 0,
          stagger: 0.08
        });

        if (heroActions.length) {
          heroTimeline.from(heroActions, {
            y: 10,
            autoAlpha: 0,
            duration: 0.45,
            stagger: 0.08
          }, "<0.35");
        }
      } else {
        revealGroup(heroIntro, {
          y: 16,
          stagger: 0.08,
          duration: 0.58
        });

        revealGroup(heroActions, {
          y: 10,
          stagger: 0.08,
          duration: 0.42
        });
      }
    }

    if (!("IntersectionObserver" in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var section = entry.target;
        observer.unobserve(section);

        if (section.classList.contains("kll-june-campaign")) {
          revealGroup(section.querySelectorAll(".kll-june-campaign__header > *, .kll-june-reward-card, .kll-june-campaign__actions > *"), {
            stagger: 0.06,
            y: 14
          });
        } else if (section.classList.contains("kll-june-shop")) {
          revealGroup(section.querySelectorAll(".kll-june-shop__head > *, .kll-june-tabs, .kll-june-cart-rail, [data-kll-product-card]:not([hidden])"), {
            stagger: 0.045,
            y: 12
          });
        } else if (section.classList.contains("kll-june-faq")) {
          revealGroup(section.querySelectorAll(".kll-june-faq__head > *, .kll-june-faq__item"), {
            stagger: 0.06,
            y: 12
          });
        }
      });
    }, {
      threshold: 0.16
    });

    page.querySelectorAll(".kll-june-campaign, .kll-june-shop, .kll-june-faq").forEach(function (section) {
      observer.observe(section);
    });
  }

  function setupTabScrollHint(page) {
    var tabs = page.querySelector(".kll-june-tabs");
    if (!tabs) return;

    function updateHint() {
      var maxScroll = tabs.scrollWidth - tabs.clientWidth;
      // No overflow, or scrolled (almost) to the end -> drop the fade hint
      var atEnd = maxScroll <= 1 || tabs.scrollLeft >= maxScroll - 2;
      tabs.classList.toggle("is-scroll-end", atEnd);
    }

    tabs.addEventListener("scroll", updateHint, { passive: true });
    window.addEventListener("resize", updateHint);
    updateHint();

    function resetHorizontalDrift() {
      var node = tabs.parentElement;

      while (node && node !== document.body && node !== document.documentElement) {
        if (node !== tabs && node.scrollLeft) {
          node.scrollLeft = 0;
        }
        node = node.parentElement;
      }

      if (document.documentElement.scrollLeft) {
        document.documentElement.scrollLeft = 0;
      }
      if (document.body.scrollLeft) {
        document.body.scrollLeft = 0;
      }
    }

    // Keep the active tab visible without letting Shopify's mobile preview
    // horizontally scroll the whole page.
    tabs.querySelectorAll("[data-kll-filter]").forEach(function (tab) {
      tab.addEventListener("click", function () {
        resetHorizontalDrift();

        var maxScroll = tabs.scrollWidth - tabs.clientWidth;
        if (maxScroll <= 1) {
          resetHorizontalDrift();
          return;
        }

        var tabLeft = tab.offsetLeft;
        var tabWidth = tab.offsetWidth;
        var targetLeft = tabLeft - (tabs.clientWidth - tabWidth) / 2;
        targetLeft = Math.max(0, Math.min(maxScroll, targetLeft));

        if (typeof tabs.scrollTo === "function") {
          tabs.scrollTo({ left: targetLeft, behavior: "smooth" });
        } else {
          tabs.scrollLeft = targetLeft;
        }

        resetHorizontalDrift();
        window.requestAnimationFrame(resetHorizontalDrift);
        window.setTimeout(resetHorizontalDrift, 160);
      });
    });
  }

  function setupFaq(page) {
    page.querySelectorAll(".kll-june-faq__question").forEach(function (button) {
      button.addEventListener("click", function () {
        var item = button.closest(".kll-june-faq__item");
        var isOpen = item && item.classList.contains("is-open");

        page.querySelectorAll(".kll-june-faq__item").forEach(function (faqItem) {
          var faqButton = faqItem.querySelector(".kll-june-faq__question");
          faqItem.classList.remove("is-open");
          if (faqButton) faqButton.setAttribute("aria-expanded", "false");
        });

        if (item && !isOpen) {
          item.classList.add("is-open");
          button.setAttribute("aria-expanded", "true");
        }
      });
    });
  }

  var pages = document.querySelectorAll("[data-kll-june-page]");
  if (!pages.length) return;

  pages.forEach(function (page) {
    FIRST_REWARD_NAME = page.getAttribute("data-kll-first-reward-name") || FIRST_REWARD_NAME;
    SECOND_REWARD_NAME = page.getAttribute("data-kll-second-reward-name") || SECOND_REWARD_NAME;
    FIRST_REWARD_URL = page.getAttribute("data-kll-first-reward-url") || FIRST_REWARD_URL;
    SECOND_REWARD_URL = page.getAttribute("data-kll-second-reward-url") || SECOND_REWARD_URL;
    FIRST_REWARD_IMAGE = page.getAttribute("data-kll-first-reward-image") || FIRST_REWARD_IMAGE;
    SECOND_REWARD_IMAGE = page.getAttribute("data-kll-second-reward-image") || SECOND_REWARD_IMAGE;

    var state = {
      baseCents: Number(page.getAttribute("data-kll-cart-cents")) || 0,
      items: []
    };

    page.querySelectorAll("[data-kll-scroll-target]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        var selector = button.getAttribute("data-kll-scroll-target");
        var target = selector ? page.querySelector(selector) || document.querySelector(selector) : null;

        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      });
    });

    page.querySelectorAll("[data-kll-filter]").forEach(function (tab) {
      tab.addEventListener("click", function () {
        var category = tab.getAttribute("data-kll-filter");
        page.querySelectorAll("[data-kll-filter]").forEach(function (otherTab) {
          var isActive = otherTab === tab;
          otherTab.classList.toggle("is-active", isActive);
          otherTab.setAttribute("aria-selected", String(isActive));
        });

        page.querySelectorAll("[data-kll-product-card]").forEach(function (card) {
          card.hidden = card.getAttribute("data-category") !== category;
        });

        revealGroup(page.querySelectorAll('[data-kll-product-card][data-category="' + category + '"]:not([hidden])'), {
          stagger: 0.035,
          y: 10,
          duration: 0.46
        });
      });
    });

    page.querySelectorAll("[data-kll-cart-add]").forEach(function (button) {
      button.addEventListener("click", function () {
        var title = button.getAttribute("data-title") || "Selected product";
        var priceCents = Number(button.getAttribute("data-price-cents")) || 0;
        var variantId = button.getAttribute("data-variant-id");
        var originalText = button.textContent;

        button.disabled = true;
        button.textContent = "Adding...";

        addVariantToShopifyCart(variantId).then(function () {
          state.items.push({
            title: title,
            priceCents: priceCents
          });

          button.classList.add("is-added");
          button.textContent = "Added";
          if (canAnimate()) {
            animateFromTo(button, {
              scale: 0.98
            }, {
              scale: 1,
              duration: 0.18,
              ease: "power2.out",
              overwrite: "auto",
              clearProps: "transform"
            });
          }
          updateRewardCart(page, state);
        }).catch(function () {
          button.textContent = "Try again";
        }).finally(function () {
          window.setTimeout(function () {
            button.disabled = false;
            button.classList.remove("is-added");
            button.textContent = originalText;
          }, 1200);
        });
      });
    });

    setupEntranceAnimations(page);
    setupRewardBarBehavior(page);
    setupTabScrollHint(page);
    setupFaq(page);
    updateRewardCart(page, state);
  });
})();
